import { type SVGProps } from "react";

// Icons from the onboarding Figma ("Icon / user", "Icon / file-text", ...),
// drawn from the design's own stroke paths. They stroke with currentColor, so
// CSS sets the colour.
type IconData = { size: number; strokeWidth: number; paths: string[] };

const ICONS = {
  user: {
    size: 14,
    strokeWidth: 1.16667,
    paths: [
      "M9.91667 4.66667C9.91667 6.2775 8.61083 7.58333 7 7.58333C5.38917 7.58333 4.08333 6.2775 4.08333 4.66667C4.08333 3.05584 5.38917 1.75 7 1.75C8.61083 1.75 9.91667 3.05584 9.91667 4.66667Z",
      "M11.6667 12.25C11.6667 11.0123 11.175 9.82534 10.2998 8.95017C9.42466 8.075 8.23768 7.58333 7 7.58333C5.76232 7.58333 4.57534 8.075 3.70017 8.95017C2.825 9.82534 2.33333 11.0123 2.33333 12.25",
    ],
  },
  file: {
    size: 14,
    strokeWidth: 1.16667,
    paths: [
      "M8.16667 1.16667H3.5C3.19058 1.16667 2.89383 1.28958 2.67504 1.50838C2.45625 1.72717 2.33333 2.02391 2.33333 2.33333V11.6667C2.33333 11.9761 2.45625 12.2728 2.67504 12.4916C2.89383 12.7104 3.19058 12.8333 3.5 12.8333H10.5C10.8094 12.8333 11.1062 12.7104 11.325 12.4916C11.5437 12.2728 11.6667 11.9761 11.6667 11.6667V4.66667L8.16667 1.16667Z",
      "M8.16667 1.16667V4.66667H11.6667",
      "M9.33333 7.58333H4.66667",
      "M9.33333 9.91667H4.66667",
      "M5.83333 5.25H4.66667",
    ],
  },
  news: {
    size: 14,
    strokeWidth: 1.16667,
    paths: [
      "M2.33333 12.8333H11.6667C11.9761 12.8333 12.2728 12.7104 12.4916 12.4916C12.7104 12.2728 12.8333 11.9761 12.8333 11.6667V2.33333C12.8333 2.02391 12.7104 1.72717 12.4916 1.50838C12.2728 1.28958 11.9761 1.16667 11.6667 1.16667H4.66667C4.35725 1.16667 4.0605 1.28958 3.84171 1.50838C3.62292 1.72717 3.5 2.02391 3.5 2.33333V5.25M2.33333 12.8333C2.64275 12.8333 2.9395 12.7104 3.15829 12.4916C3.37708 12.2728 3.5 11.9761 3.5 11.6667V5.25M2.33333 12.8333C2.02391 12.8333 1.72717 12.7104 1.50838 12.4916C1.28958 12.2728 1.16667 11.9761 1.16667 11.6667V6.41667C1.16667 5.775 1.69167 5.25 2.33333 5.25H3.5",
      "M10.5 8.16667H5.83333",
      "M8.75 10.5H5.83333",
      "M5.83333 3.5H10.5V5.83333H5.83333V3.5Z",
    ],
  },
  eraser: {
    size: 14,
    strokeWidth: 1.16667,
    paths: [
      "M4.08333 12.25L1.575 9.74167C0.991667 9.15833 0.991667 8.28333 1.575 7.75833L7.175 2.15833C7.75833 1.575 8.63333 1.575 9.15833 2.15833L12.425 5.425C13.0083 6.00833 13.0083 6.88333 12.425 7.40833L7.58333 12.25",
      "M12.8333 12.25H4.08333",
      "M2.91667 6.41667L8.16667 11.6667",
    ],
  },
  image: {
    size: 14,
    strokeWidth: 1.16667,
    paths: [
      "M2.91667 1.75H11.0833C11.7277 1.75 12.25 2.27233 12.25 2.91667V11.0833C12.25 11.7277 11.7277 12.25 11.0833 12.25H2.91667C2.27233 12.25 1.75 11.7277 1.75 11.0833V2.91667C1.75 2.27233 2.27233 1.75 2.91667 1.75Z",
      "M6.41667 5.25C6.41667 5.89433 5.89433 6.41667 5.25 6.41667C4.60567 6.41667 4.08333 5.89433 4.08333 5.25C4.08333 4.60567 4.60567 4.08333 5.25 4.08333C5.89433 4.08333 6.41667 4.60567 6.41667 5.25Z",
      "M12.25 8.75L10.4417 6.94167C10.2236 6.7279 9.93038 6.60817 9.625 6.60817C9.31962 6.60817 9.02642 6.7279 8.80833 6.94167L3.5 12.25",
    ],
  },
  wand: {
    size: 14,
    strokeWidth: 1.16667,
    paths: [
      "M12.6233 2.12333L11.8767 1.37667C11.811 1.31035 11.7329 1.25771 11.6468 1.22178C11.5607 1.18585 11.4683 1.16735 11.375 1.16735C11.2817 1.16735 11.1893 1.18585 11.1032 1.22178C11.0171 1.25771 10.939 1.31035 10.8733 1.37667L1.37667 10.8733C1.31035 10.939 1.25771 11.0171 1.22178 11.1032C1.18585 11.1893 1.16735 11.2817 1.16735 11.375C1.16735 11.4683 1.18585 11.5607 1.22178 11.6468C1.25771 11.7329 1.31035 11.811 1.37667 11.8767L2.12333 12.6233C2.18856 12.6904 2.26656 12.7436 2.35273 12.78C2.43889 12.8164 2.53147 12.8351 2.625 12.8351C2.71853 12.8351 2.81111 12.8164 2.89727 12.78C2.98344 12.7436 3.06144 12.6904 3.12667 12.6233L12.6233 3.12667C12.6904 3.06144 12.7436 2.98344 12.78 2.89727C12.8164 2.81111 12.8351 2.71853 12.8351 2.625C12.8351 2.53147 12.8164 2.43889 12.78 2.35273C12.7436 2.26656 12.6904 2.18856 12.6233 2.12333Z",
      "M8.16667 4.08333L9.91667 5.83333",
      "M2.91667 3.5V5.83333",
      "M11.0833 8.16667V10.5",
      "M5.83333 1.16667V2.33333",
      "M4.08333 4.66667H1.75",
      "M12.25 9.33333H9.91667",
      "M6.41667 1.75H5.25",
    ],
  },
  megaphone: {
    size: 14,
    strokeWidth: 1.16667,
    paths: [
      "M1.75 6.41667L12.25 3.5V10.5L1.75 8.16667V6.41667Z",
      "M6.76667 9.8C6.70538 10.0222 6.60094 10.2301 6.45931 10.4119C6.31768 10.5936 6.14163 10.7458 5.94121 10.8595C5.74079 10.9733 5.51992 11.0464 5.29123 11.0748C5.06253 11.1032 4.83049 11.0863 4.60833 11.025C4.38618 10.9637 4.17827 10.8593 3.99648 10.7176C3.81469 10.576 3.66258 10.4 3.54883 10.1995C3.43508 9.99912 3.36191 9.77826 3.33352 9.54956C3.30512 9.32087 3.32205 9.08882 3.38333 8.86667",
    ],
  },
  sparkles: {
    size: 11,
    strokeWidth: 0.916667,
    paths: [
      "M5.5 1.375L4.62917 4.03333C4.58474 4.17306 4.50745 4.30009 4.40377 4.40377C4.30009 4.50745 4.17306 4.58474 4.03333 4.62917L1.375 5.5L4.03333 6.37083C4.17306 6.41526 4.30009 6.49255 4.40377 6.59623C4.50745 6.69991 4.58474 6.82694 4.62917 6.96667L5.5 9.625L6.37083 6.96667C6.41526 6.82694 6.49255 6.69991 6.59623 6.59623C6.69991 6.49255 6.82694 6.41526 6.96667 6.37083L9.625 5.5L6.96667 4.62917C6.82694 4.58474 6.69991 4.50745 6.59623 4.40377C6.49255 4.30009 6.41526 4.17306 6.37083 4.03333L5.5 1.375Z",
    ],
  },
  "arrow-left": {
    size: 16,
    strokeWidth: 1.33333,
    paths: ["M8 12.6667L3.33333 8L8 3.33333", "M12.6667 8H3.33333"],
  },
  "arrow-right": {
    size: 16,
    strokeWidth: 1.33333,
    paths: ["M3.33333 8H12.6667", "M8 3.33333L12.6667 8L8 12.6667"],
  },
  check: {
    size: 13,
    strokeWidth: 1.08333,
    paths: ["M10.8333 3.25L4.875 9.20833L2.16667 6.5"],
  },
} satisfies Record<string, IconData>;

export type OnboardingIconName = keyof typeof ICONS;

type OnboardingIconProps = {
  name: OnboardingIconName;
  // Rendered size in px; defaults to the size it was drawn at in Figma.
  size?: number;
} & Omit<SVGProps<SVGSVGElement>, "name">;

export function OnboardingIcon({ name, size, ...props }: OnboardingIconProps) {
  const icon: IconData = ICONS[name];
  const renderedSize = size ?? icon.size;
  return (
    <svg
      width={renderedSize}
      height={renderedSize}
      viewBox={`0 0 ${icon.size} ${icon.size}`}
      fill="none"
      stroke="currentColor"
      strokeWidth={icon.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}>
      {icon.paths.map((path) => (
        <path key={path} d={path} />
      ))}
    </svg>
  );
}
